<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <v-container>
        <v-row align="end">
          <v-col>
            <div class="page-title">
              <a @click.stop="goToUsersManagement"
                ><v-icon class="mr-3">fal fa-arrow-left</v-icon></a
              >
              <h1>{{ moduleTitle }} de Usuário</h1>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-form ref="registerUserForm" v-model="isUserFormValid">
        <v-container>
          <!-- Card-1 -->
          <v-card elevation="8" class="pb-4">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container class="d-flex align-center justify-space-between">
                <span class="list-labels">Dados básicos</span>
                <div class="d-flex flex-row align-center">
                  <span class="list-labels">Inativo</span>
                  <v-switch class="ml-4" inset v-model="userActive"></v-switch>
                </div>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="py-0">
              <v-container py-0>
                <v-row>
                  <!-- avatar ###################################### -->
                  <v-col class="flex-shrink-0 flex-grow-0 pt-4">
                    <span class="avatar p-relative">
                      <!-- <v-btn color="var(--secondary)" fab depressed>
                                                <v-icon class="white--text">fal fa-camera</v-icon>
                                            </v-btn> -->
                      <v-avatar size="150" class="border-avatar">
                        <img
                          :src="
                            `https://ui-avatars.com/api/?name=${userName}&size=160`
                          "
                        />
                      </v-avatar>
                    </span>
                  </v-col>
                  <!-- form dados básicos ###################################### -->
                  <v-col class="flex-grow-1">
                    <v-container fluid pa-0>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Nome"
                            outlined
                            hide-details="auto"
                            required
                            v-model="userName"
                            :rules="[validateUserName]"
                            :disabled="registerUser"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="CPF"
                            v-mask="['###.###.###-##']"
                            outlined
                            hide-details="auto"
                            required
                            v-model="userDocument"
                            :rules="[validateUserDocument]"
                            :disabled="registerUser"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Celular"
                            v-model="userPhone"
                            v-mask="['(##) #####-####', '(##) ####-####']"
                            outlined
                            hide-details="auto"
                            required
                            :rules="[validateUserPhone]"
                            :disabled="registerUser"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="userEmail"
                            label="E-mail"
                            outlined
                            hide-details="auto"
                            required
                            :rules="[validateUserEmail]"
                            :disabled="registerUser"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- Não remover o botão, usado para quebrar o form no responsivo ################################ -->
                      <v-row>
                        <v-col>
                          <v-btn
                            disabled
                            depressed
                            color="var(--feature)"
                            dark
                            rounded
                            large
                            class="px-12 op-0"
                            @click="showChangePassword = !showChangePassword"
                          >
                            <v-icon class="mr-3" small>fal fa-lock</v-icon
                            >Alterar Senha
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <v-container class="mt-10 pt-5">
          <v-card elevation="8" class="pb-4">
            <v-card-title class="pb-0">
              <v-container class="d-flex align-center justify-space-between">
                <span class="list-labels">Entidades</span>
                <div class="d-flex flex-row align-center">
                  <v-btn
                    @click="AddNewEntity()"
                    color="secondary"
                    rounded
                    large
                    depressed
                    class="px-12 mr-1 white--text"
                    :disabled="!isUserFormValid"
                    >+ Adicionar Entidade</v-btn
                  >
                </div>
              </v-container>
            </v-card-title>

            <v-container>
              <div>
                <template v-for="(entity, index) in entityList">
                  <v-divider
                    v-if="index > 0"
                    :key="'entity' + index"
                  ></v-divider>
                  <v-layout
                    :key="entity.id"
                    class="main-list-item"
                    align-center
                  >
                    <v-col
                      cols="12"
                      md="6"
                      lg="auto"
                      class="pb-0 benfeitor flex-grow-1 flex-shrink-0"
                      style="width:300px"
                    >
                      <v-flex pl-2 pt-sm-0 pt-12>
                        <h4 class="font-weight-regular">
                          {{ entity.entityViewModel.name }}
                          <span class="caption op-5">
                            ({{
                              GetEntityType(entity.entityViewModel.entityType)
                            }})</span
                          >
                        </h4>
                      </v-flex>
                    </v-col>
                    <div class="tools">
                      <v-container fluid pa-0>
                        <v-row no-wrap align="center" no-gutters>
                          <!-- edit & on/off #########################-->
                          <v-col cols="auto">
                            <v-layout
                              align-center
                              class="d-none d-md-flex flex-grow-0"
                            >
                              <v-flex pl-6>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      fab
                                      small
                                      color="var(--gray)"
                                      class="hover-red"
                                      v-on="on"
                                      @click="editEntity(entity, index)"
                                    >
                                      <v-icon size="20">fal fa-pen</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Editar</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex pl-6>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      fab
                                      small
                                      color="var(--gray)"
                                      class="hover-red"
                                      v-on="on"
                                      @click="deleteUserEntity(entity, index)"
                                    >
                                      <v-icon size="20">fal fa-trash</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Excluir</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex pl-6>
                                <v-switch v-model="entity.active" inset>
                                </v-switch>
                              </v-flex>
                            </v-layout>
                          </v-col>
                        </v-row>
                      </v-container>
                    </div>
                  </v-layout>
                </template>
              </div>
            </v-container>
          </v-card>
        </v-container>

        <!-- Modal dialog para adicionar entidade -->
        <v-dialog v-model="showEntityForm" persistent max-width="500">
          <v-card>
            <v-card-title>
              <h5 class="pt-5 pb-7">Entidade</h5>
            </v-card-title>
            <v-card-text class="align-center justify-center">
              <v-form ref="entityForm" v-model="isUSerEntityFormValid">
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="selectedEntityType"
                      :items="entityTypeList"
                      required
                      label="Entidade"
                      item-text="name"
                      outlined
                      return-object
                      hide-details="auto"
                      :rules="[validateEntityTypeOption]"
                      @change="validateEntity"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="selectedSecretary"
                      :items="secretariesList"
                      item-text="entityViewModel.name"
                      label="Secretaria"
                      outlined
                      hide-details="auto"
                      return-object
                      :rules="[validateSecretariesList]"
                      v-if="isSecretarySelected"
                    ></v-select>
                    <v-select
                      v-model="selectedInstitution"
                      :items="institutionsList"
                      item-text="entityViewModel.name"
                      label="Instituição"
                      outlined
                      hide-details="auto"
                      return-object
                      :rules="[validateInstitutionList]"
                      v-if="isInstitutionSelected"
                    ></v-select>
                    <v-select
                      :items="councilList"
                      item-text="entityViewModel.name"
                      label="Conselho"
                      outlined
                      return-object
                      hide-details="auto"
                      v-model="selectedCouncil"
                      :rules="[validateCouncilList]"
                      v-if="isCouncilSelected"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="selectedJobRole"
                      :items="jobRolesList"
                      item-text="name"
                      label="Cargo"
                      return-object
                      outlined
                      hide-details="auto"
                      :rules="[validateJobRoleOption]"
                      v-if="
                        isSecretarySelected ||
                          isInstitutionSelected ||
                          isCouncilSelected
                      "
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-col cols="12" md="4">
              <v-checkbox
                v-if="isCouncilSelected"
                v-model="financial"
                dense
                label="Perfil Financeiro"
                color="var(--secondary)"
              ></v-checkbox>
              <v-checkbox
                v-if="!isBenefactorSelected"
                v-model="administrator"
                label="Administrador"
                color="var(--secondary)"
              ></v-checkbox>
            </v-col>
            <v-card-actions class="px-6 py-5 d-flex space-between">
              <v-btn
                rounded
                large
                depressed
                outlined
                class="gray px-12"
                @click="hide()"
                >Voltar</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="info"
                rounded
                large
                depressed
                class="px-12"
                :disabled="!isUSerEntityFormValid"
                @click="SaveEntity()"
                >Salvar Entidade</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- crud message dialog ######################################
                 <CrudMessageResponse 
                    :showMessage = showSaveUserMessage
                    :message = userCrudMessage
                 /> -->

        <v-dialog v-model="showMessage" persistent max-width="490">
          <v-card>
            <v-card-title>
              <h5 class="pt-5 pb-7">Mensagem</h5>
            </v-card-title>
            <v-card-text>{{ message }}</v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions class="px-6 py-5">
              <v-btn
                color="gray"
                text
                large
                class="px-12"
                @click="closeCrudMessage()"
                >Entendi</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- buttons float ###################################### -->
        <template>
          <v-footer fixed color="transparent" padless class="justify-center">
            <v-card elevation="6" class="pt-3 pb-4 px-4 footer-card">
              <v-btn
                @click="goToUsersManagement()"
                color="secondary"
                rounded
                large
                depressed
                class="px-12 mr-1 white--text footer-border-left"
                >Voltar</v-btn
              >
              <v-btn
                color="secondary"
                rounded
                large
                depressed
                class="px-12 ml-1 footer-border-right"
                :disabled="VerifySaveButtoIsAvailable()"
                @click="saveUser()"
                >Salvar</v-btn
              >
            </v-card>
          </v-footer>
        </template>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import Routes from "@/router/names.js";
import CommonHelper from "@/scripts/helpers/common.helper";
import EntityService from "@/scripts/services/entity.service";
import AuthService from "@/scripts/services/auth.service";
import EntityTypes from "@/scripts/enums/entityTypes.enum";
import { mapGetters, mapActions } from "vuex";
// import CrudMessageResponse from "@/components/CrudMessageResponse";
import JobRoles from "@/scripts/enums/jobRoles.enum";

export default {
  name: "UserRegister",
  components: {
    NavBar
    // CrudMessageResponse
  },
  data: () => ({
    entityService: new EntityService(),
    authService: new AuthService(),
    Active: true,
    isUserFormValid: false,
    isUSerEntityFormValid: false,
    registerUser: false,
    userActive: false,

    //Form data
    showMessage: false,
    message: "",

    //User Form Data
    userName: "",
    userDocument: "",
    userPhone: "",
    userEmail: "",
    entityList: [],

    //User data control
    userFromDatabase: {},

    //Module Title
    moduleTitle: "Cadastro",

    showEntityForm: false,
    isFormValid: false,
    entityTypeList: [],
    selectedEntityType: null,
    jobRolesList: [],
    selectedJobRole: null,
    secretariesList: [],
    selectedSecretary: null,
    institutionsList: [],
    selectedInstitution: null,
    councilList: [],
    selectedCouncil: null,
    financial: false,
    administrator: false,
    selectedBenefactor: false,

    isEdit: false,
    editEntityViewModelIndex: 0
  }),
  computed: {
    ...mapGetters(["selectedUser"]),
    ...mapGetters("userModule", ["loggedEntityId","isBenefactor" ,"isAdminOfLoggedCouncilOrBenefactor","getTypeOfLoggedEntity"]),
    isCouncilSelected() {
      return (
        this.selectedEntityType &&
        this.selectedEntityType.id == EntityTypes.Council
      );
    },
    isInstitutionSelected() {
      return (
        this.selectedEntityType &&
        this.selectedEntityType.id == EntityTypes.Institution
      );
    },
    isSecretarySelected() {
      return (
        this.selectedEntityType &&
        this.selectedEntityType.id == EntityTypes.Secretary
      );
    },
    isBenefactorSelected() {
      return (
        this.selectedEntityType &&
        this.selectedEntityType.id == EntityTypes.Benefactor
      );
    },
    isPresidentSelected() {
      return (
        this.selectedJobRole && this.selectedJobRole.id == JobRoles.President
      );
    },
    isRepresentativetSelected() {
      return (
        this.selectedJobRole &&
        this.selectedJobRole.id == JobRoles.Representative
      );
    },
    isOthersSelected() {
      return this.selectedJobRole && this.selectedJobRole.id == JobRoles.Others;
    }
  },
  mounted() {
    if (
      this.$route.params.userId &&
      this.selectedUser &&
      this.selectedUser.userViewModel.id == this.$route.params.userId
    ) {
      this.moduleTitle = "Edição";
      this.userName = this.selectedUser.personViewModel.fullName;
      this.userDocument = this.selectedUser.personViewModel.document;
      this.userPhone = this.selectedUser.personViewModel.phone;
      this.userEmail = this.selectedUser.userViewModel.email;
      this.userActive = !this.selectedUser.userViewModel.active;

      this.GetAllUserEntities(this.selectedUser.userViewModel.id);

      // this.selectedEntityType = this.GetEntityTypeSelectedAndResolveFields(this.selectedUser.entityViewModel.entityType);
    } else if (this.$route.params.userId) {
      this.getUserByIdAndFillFields(this.$route.params.userId);
    } else {
      this.setSelectedUser(null);
    }
  },
  created() {
    this.entityService
      .listAllEntityTypes()
      .then(result => (this.entityTypeList = result.filter(e => {
        return this.isBenefactor
            || (this.getTypeOfLoggedEntity == EntityTypes.Council && e.id < 3)
            || (this.getTypeOfLoggedEntity == EntityTypes.Secretary && e.id < 4)
            || (this.getTypeOfLoggedEntity == EntityTypes.Institution && e.id == 2)
      })));

    this.entityService
      .listAllJobRoles()
      .then(result => (this.jobRolesList = result));
  },
  methods: {
    ...mapActions(["setSelectedUser"]),
    GetAllUserEntities(userId) {
      this.authService
        .listAllUserEntities(userId, this.loggedEntityId)
        .then(result => (this.entityList = result));

      this.entityService
        .listSecretaries(this.getFilters())
        .then(result => (this.secretariesList = result));

      this.entityService
        .listInstitutions(this.getFilters())
        .then(result => (this.institutionsList = result));
    },
    getFilters() {
      return {
        orderBy: this.selectedOrderBy,
        currentPage: this.currentPage - 1,
        pageSize: this.selectedPagination,
        searchTerms: this.searchTerms
      };
    },
    getUserByIdAndFillFields(id) {
      this.authService
        .getUserById(id)
        .then(this.getUserByIdCallBack)
        .catch(this.getUserByIdCatch);
    },
    getUserByIdCallBack(data) {
      this.setSelectedUser(data);
      this.userFromDatabase = data;

      this.userName = this.userFromDatabase.personViewModel.fullName;
      this.userDocument = this.userFromDatabase.personViewModel.document;
      this.userPhone = this.userFromDatabase.personViewModel.phone;
      this.userEmail = this.userFromDatabase.email;
      this.entityList = this.userFromDatabase.userEntityViewModels;
    },
    getUserByIdCatch() {},
    editEntity(entity, index) {
      this.selectedEntityType = this.entityTypeList.find(
        e => e.id === entity.entityViewModel.entityType
      );

      if (this.selectedEntityType.id == EntityTypes.Council) {
        this.selectedCouncil = this.entityList.find(
          e => e.entityViewModel.id === entity.entityViewModel.id
        );
      } else if (this.selectedEntityType.id == EntityTypes.Institution) {
        this.selectedInstitution = this.entityList.find(
          e => e.entityViewModel.id === entity.entityViewModel.id
        );
      } else if (this.selectedEntityType.id == EntityTypes.Secretary) {
        this.selectedSecretary = this.entityList.find(
          e => e.entityViewModel.id === entity.entityViewModel.id
        );
      } else if (this.selectedEntityType.id == EntityTypes.Benefactor) {
        this.selectedBenefactor = this.entityList.find(
          e => e.entityViewModel.id === entity.entityViewModel.id
        );        
      }

      if(this.selectedEntityType.id != EntityTypes.Benefactor){
          this.selectedJobRole = this.jobRolesList.find(
          j => j.id === entity.jobRoleId
        );
      }

      this.administrator = entity.admin;
      this.financial = entity.finance;
      this.isEdit = true;
      this.editEntityViewModelIndex = index;
      this.showEntityForm = true;
    },
    SaveEntity() {
      let entityUserViewModel = {
        admin: this.administrator,
        finance: this.financial,
        active: true
      };

      if(this.selectedJobRole){
        entityUserViewModel.jobRoleId = this.selectedJobRole.id;
      }

      if (this.isEdit) {
        if(this.selectedUser) {
          entityUserViewModel.userId = this.selectedUser.userViewModel.id;
        }
        entityUserViewModel.id = this.entityList[
          this.editEntityViewModelIndex
        ].id;
        this.entityList.splice(this.editEntityViewModelIndex, 1);
      }

      if (this.selectedEntityType.id == EntityTypes.Council) {
        entityUserViewModel.entityViewModel = this.selectedCouncil.entityViewModel;
      } else if (this.selectedEntityType.id == EntityTypes.Institution) {
        entityUserViewModel.entityViewModel = this.selectedInstitution.entityViewModel;
      } else if (this.selectedEntityType.id == EntityTypes.Secretary) {
        entityUserViewModel.entityViewModel = this.selectedSecretary.entityViewModel;
      } else if (this.selectedEntityType.id == EntityTypes.Benefactor) {
        entityUserViewModel.entityViewModel = {
          name: "Benfeitor",
          entityType: EntityTypes.Benefactor
        }
      }

      if(this.selectedEntityType.id != EntityTypes.Benefactor) {
        entityUserViewModel.entityId = entityUserViewModel.entityViewModel.id;
      }

      if (
        this.entityList.length > 0 &&
        this.entityList.find(
          e => e.entityViewModel.id === entityUserViewModel.entityViewModel.id
        )
      ) {
        this.showMessage = true;
        this.message = "Esta Entidade Já foi selecionada para este usuário";
      } else {
        this.entityList.push(entityUserViewModel);
        this.showMessage = true;
        this.message = "Entidade Salva";
      }

      this.administrator = null;
      this.financial = null;
      this.selectedJobRole = null;
      this.selectedCouncil = null;
      this.selectedInstitution = null;
      this.selectedSecretary = null;

      this.showEntityForm = false;
    },
    saveUser() {
      let user = {
        email: this.userEmail,
        active: !this.userActive,
        personViewModel: {
          document: this.userDocument,
          fullName: this.userName,
          phone: this.userPhone,
          email: this.userEmail
        },
        userEntityViewModels: this.entityList
      };

      this.showMessage = false;

      if (this.selectedUser != null) {
        user.id = this.selectedUser.userViewModel.id;

        this.authService.editUser(user).then((response) => this.crudUserCallBack(response, 'Editado'));
      } else {
        this.authService.createUser(user).then((response) => this.crudUserCallBack(response, 'Criado'));
      }
    },
    crudUserCallBack(response, text) {
      if(!response.errorMessage) {
        this.showMessage = true;
        this.message = "Usuário " + text + " com Sucesso!";
      }
    },
    goToUsersManagement() {
      this.$router.push({ name: Routes.app.UserManagement });
    },
    validateUserName() {
      if (!this.userName) return "Preencha o nome do usuário";

      if(CommonHelper.wordCount(this.userName) < 2)
        return "Informe seu Nome completo";
        
      return true;
    },
    validateUserDocument() {
      if (!this.userDocument) return "Preencha o documento";
      if (!CommonHelper.validateCPF(this.userDocument)) return "CPF inválido";
      return true;
    },
    validateUserPhone() {      
      if (!this.userPhone) return "Preencha o celular";
      if(!CommonHelper.validateCellPhone(this.userPhone))
        return "Celular Inválido";
      return true;
    },
    validateUserEmail() {
      this.userEmail = this.userEmail.trim();
      if (!this.userEmail) return "Preencha o e-mail";
      if (!CommonHelper.validateEmail(this.userEmail)) return "E-mail inválido";
      return true;
    },
    validateSecretariesList() {
      if (
        this.selectedEntityType.id == EntityTypes.Secretary &&
        !this.secretariesList
      )
        return "selecione uma secretaria";
      return true;
    },
    validateInstitutionList() {
      if (
        this.selectedEntityType.id == EntityTypes.Institution &&
        !this.institutionsList
      )
        return "selecione uma instituição";
      return true;
    },
    validateCouncilList() {
      if (
        this.selectedEntityType.id == EntityTypes.Council &&
        !this.councilList
      )
        return "selecione um conselho";
      return true;
    },
    validateEntityTypeOption() {
      if (this.selectedEntityType != null && this.selectedEntityType.id > 0)
        return true;
      return "Escolha uma opção de tipo de entidade";
    },
    validateEntity() {
      if (this.selectedEntityType.id == EntityTypes.Secretary) {
        this.entityService
          .listSecretaries(this.getFilters())
          .then(result => (this.secretariesList = result));
      } else if (this.selectedEntityType.id == EntityTypes.Institution) {
        this.entityService
          .listInstitutions(this.getFilters())
          .then(result => {
            this.institutionsList = result.filter(e => {
              console.log(e.councilEntityIds, this.loggedEntityId)
              const has = this.isBenefactor || e.councilEntityIds.includes(this.loggedEntityId) || e.entityViewModel.id == this.loggedEntityId
              return has;
            })
          });
      } else if (this.selectedEntityType.id == EntityTypes.Council) {
        this.entityService
          .listCouncils(this.getFilters())
          .then(result => {
            this.councilList = result.filter(e => {
              const has = e.entityViewModel.id == this.loggedEntityId || this.isBenefactor
              console.log('hasEntity' + e.entityViewModel.id + ':', has)
              return has;
            })
          });

      }
    },
    validateJobRoleOption() {
      if (!this.selectedJobRole != null) return true;
      return "Escolha uma opção de cargo";
    },
    hide() {
      this.showEntityForm = false;
      this.selectedEntityType = null;
      this.selectedJobRole = null;
      this.selectedSecretary = null;
      this.selectedInstitution = null;
      this.financial = false;
      this.administrator = false;
    },
    GetEntityType(entityTypeId) {
      if (entityTypeId == EntityTypes.Council) {
        return "Conselho";
      } else if (entityTypeId == EntityTypes.Institution) {
        return "Instituição";
      } else if (entityTypeId == EntityTypes.Secretary) {
        return "Secretaria";
      } else if (entityTypeId == EntityTypes.Benefactor){
        return "Admin";
      }
    },
    closeCrudMessage() {
      this.showMessage = false;
      this.message = "";
      this.messageTitle = "";

      this.selectedEntityType = null;
      this.selectedJobRole = null;
      this.selectedSecretary = null;
      this.selectedInstitution = null;
      this.financial = false;
      this.administrator = false;
    },
    deleteUserEntity(entity, index) {
      // if (entity.id) {
      //   this.authService
      //     .deleteUserEntity(entity.id)
      //     .then(this.deleteUserEntityCallBack);
      // } else {
      this.entityList.splice(index, 1);
      // }
    },
    updateUserEntityStatus(entity) {
      if (entity.id) {
        this.authService.updateUserEntityStatus(entity.id);
      }
    },
    deleteUserEntityCallBack() {
      this.showMessage = true;
      this.message = "Entidade foi removida do usuário";
    },
    VerifySaveButtoIsAvailable() {
      if (
        this.userName &&
        this.userDocument &&
        this.userPhone &&
        this.userEmail &&
        this.entityList.length > 0
      ) {
        return false;
      }
      return true;
    },
    AddNewEntity() {
      this.isEdit = false;
      this.showEntityForm = !this.showEntityForm;
    }
  }
};
</script>